cockpitApp.directive('overview', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/view/overview',
    controllerAs: 'overviewCtrl',
    controller: 'overviewController'
  };
});
